module.exports = __webpack_public_path__ + "img/overpass.c6e547fe.svg";